import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-foreground-950">{t("brand.name")}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{t("footer.tagline")}</p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.quickLinks")}</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li>
                <Link to={`/${lang}`} className="hover:text-foreground-950 transition">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to={`/${lang}/article/usfans-shopping-guide`} className="hover:text-foreground-950 transition">
                  {t("nav.shoppingGuide")}
                </Link>
              </li>
              <li>
                <Link to={`/${lang}/article/usfans-spreadsheet-guide`} className="hover:text-foreground-950 transition">
                  {t("nav.guides")}
                </Link>
              </li>
              <li>
                <Link to={`/${lang}/safety`} className="hover:text-foreground-950 transition">
                  {t("nav.safety")}
                </Link>
              </li>
              <li>
                <Link to={`/${lang}/faq`} className="hover:text-foreground-950 transition">
                  {t("nav.faq")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.legal")}</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li><span>About</span></li>
              <li><span>Contact</span></li>
              <li><span>Privacy Policy</span></li>
              <li><span>Terms</span></li>
              <li><span>Disclaimer</span></li>
            </ul>
          </div>
        </div>

        {/* Categories with images */}
        <div className="mt-10 pt-8 border-t border-background-200">
          <h4 className="text-sm font-semibold text-foreground-950 mb-5">{t("footer.categories")}</h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3">
            {categories.map((c) => (
              <a
                key={c.name}
                href={c.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-2.5 rounded-lg border border-background-200 bg-background-50 p-2 hover:border-primary-300 transition"
              >
                <span className="w-10 h-10 rounded-md overflow-hidden shrink-0">
                  <img
                    src={c.image}
                    alt={c.name}
                    title={c.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </span>
                <span className="text-xs font-medium text-foreground-800 leading-tight">{c.name}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">{t("footer.disclaimer")}</p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            © {new Date().getFullYear()} {t("brand.name")} — {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}